
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainColour as ObiLightRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-colour.js';
 
 
 

 
 export const ObiLightRainColour = createComponent({
   react: React,
   tagName: 'obi-light-rain-colour',
   elementClass: ObiLightRainColourElement,
   events: {
     
   }
  });
 
 